module.exports = __webpack_public_path__ + "static/media/already-unsubscribed.25e2cc2e.svg";